import { render, staticRenderFns } from "./AuthTokenSetup.vue?vue&type=template&id=5c2b68c6&scoped=true"
import script from "./AuthTokenSetup.vue?vue&type=script&lang=ts"
export * from "./AuthTokenSetup.vue?vue&type=script&lang=ts"
import style0 from "./AuthTokenSetup.vue?vue&type=style&index=0&id=5c2b68c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b68c6",
  null
  
)

export default component.exports